import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const BrainIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <>
      {/* Left lobe */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11 3c-1.933 0-3.5 1.567-3.5 3.5V8H7a3 3 0 0 0 0 6h.5v1a3.5 3.5 0 1 0 7 0V6.5C14.5 4.567 12.933 3 11 3z"
      />
      {/* Right lobe */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 3c1.933 0 3.5 1.567 3.5 3.5V8H17a3 3 0 1 1 0 6h-.5v1a3.5 3.5 0 1 1-7 0V6.5C9.5 4.567 11.067 3 13 3z"
      />
      {/* Brain fold hint */}
      <path d="M10 9.5c.8-.5 1.6-.5 2.5 0" />
      <path d="M10 12c.8-.5 1.6-.5 2.5 0" />
    </>
  );

  return (
    <Icon
      svgPath={svgPath}
      className={className}
      title={title}
      fill="none"
      strokeWidth={1.5}
    />
  );
};

export default BrainIcon;
